const treeShake = <T extends object>(
  obj: T,
  /* eslint-disable @typescript-eslint/no-explicit-any */
  discardValue: any = undefined,
): Partial<T> => {
  const newObj = {} as Partial<T>
  const entries = Object.entries(obj) as [keyof T, any][]
  /* eslint-enable @typescript-eslint/no-explicit-any */
  entries.forEach(([key, val]) => {
    if (val !== discardValue) {
      newObj[key] = val
    }
  })

  return newObj
}

export default treeShake
